export const labelClass =
  'mb-1.5 block text-[length:var(--font-size-sm)] font-medium text-[var(--foreground)]'

export const inputClass =
  'ui-input-base h-[var(--control-height)] min-h-[var(--control-height)] w-full rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--card)] px-3.5 text-[length:var(--font-size-sm)] text-[var(--foreground)] shadow-[var(--shadow-xs)] placeholder:text-[var(--muted-foreground)] transition-[border-color,box-shadow] focus:border-[var(--ring)] focus:outline-none focus:ring-2 focus:ring-[color-mix(in_oklab,var(--ring)_25%,transparent)] disabled:cursor-not-allowed disabled:opacity-50'

export const textareaClass =
  'ui-input-base min-h-[96px] w-full resize-y rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--card)] px-3.5 py-2.5 text-sm text-[var(--foreground)] shadow-[var(--shadow-xs)] placeholder:text-[var(--muted-foreground)] transition-[border-color,box-shadow] focus:border-[var(--ring)] focus:outline-none focus:ring-2 focus:ring-[color-mix(in_oklab,var(--ring)_25%,transparent)]'

export const helperClass = 'mt-1 text-xs text-[var(--muted-foreground)]'
export const errorClass = 'mt-1 text-xs text-[var(--destructive)]'

export const cardClass =
  'rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--card)] shadow-[var(--shadow-sm)]'

export const btnPrimaryClass =
  'ui-btn ui-btn-primary !border-transparent shadow-[var(--shadow-glow)] hover:!opacity-92 focus-visible:!ring-[var(--ring)]'

export const btnSecondaryClass =
  'inline-flex items-center justify-center rounded-[var(--radius-md)] border border-[var(--border)] bg-[var(--card)] text-[var(--foreground)] shadow-[var(--shadow-xs)] transition-colors hover:bg-[var(--accent)] focus-visible:ring-2 focus-visible:ring-[var(--ring)]'

export const tableWrapClass =
  'ui-table-wrapper overflow-x-auto rounded-xl border border-[var(--border)] bg-[var(--card)] shadow-sm'

export const tableClass = 'ui-table w-full caption-bottom text-sm'

export const tableHeadClass =
  'ui-table-thead [&_tr]:border-b border-[var(--border)] bg-[var(--muted)]/40'

export const tableThClass =
  'ui-table-th h-10 px-2 text-left align-middle text-sm font-medium text-[var(--muted-foreground)]'

export const tableTdClass = 'ui-table-cell p-2 align-middle text-[var(--foreground)]'

export const tableRowClass =
  'ui-table-row border-b border-[var(--border)] transition-colors hover:bg-[var(--muted)]/50'
